import styles from "./EmptyState.module.scss";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import { clsx } from "clsx";
import {
  cloneElement,
  ComponentPropsWithoutRef,
  ReactElement,
  ReactNode,
} from "react";

interface EmptyStateProps {
  graphic?: ReactElement;
  title: ReactNode;
  body: ReactNode;
  buttonProps?: DistributiveOmit<
    ComponentPropsWithoutRef<typeof BaseLinkOrButton>,
    "className"
  >;
  size?: "small";
  className?: string;
  buttonPrompt?: ReactNode;
}

export default function EmptyState({
  graphic,
  title,
  body,
  buttonProps,
  size,
  className,
  buttonPrompt,
}: EmptyStateProps) {
  return (
    <div
      className={clsx(
        styles.container,
        size === "small" && styles.smallContainer,
        className
      )}
    >
      {graphic &&
        cloneElement(graphic, { "aria-hidden": true, focusable: false })}
      <h2 className="template-h3">{title}</h2>
      <div className={styles.body}>{body}</div>
      <div className={styles.buttonPrompt}>{buttonPrompt}</div>
      {buttonProps && (
        <BaseLinkOrButton
          {...buttonProps}
          className={clsx(
            "vst-button-pill",
            "vst-button-variant-outline",
            styles.button
          )}
        />
      )}
    </div>
  );
}
